import type { HttpError } from "../../http-error";
import type { FileTooLargeError } from "../file-too-large.error";

export function isFileTooLargeError(
  error: HttpError,
): error is FileTooLargeError {
  return error.isFileTooLargeError;
}
